const isProduction = process.env.NODE_ENV === 'production';

// The main bundle's content hash changes on every build, so it doubles as the deploy id
// that gives the worker a new script URL and a new shell cache.
function getBuildId() {
    const main = document.querySelector('script[src*="/static/js/main."]');
    const match = main && main.src.match(/\/static\/js\/main\.([^./]+)\.js/);
    return match ? match[1] : 'unversioned';
}

async function unregisterServiceWorkers() {
    try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        if (!registrations.length) return;

        await Promise.all(registrations.map((registration) => registration.unregister()));

        if (window.caches) {
            const keys = await caches.keys();
            await Promise.all(keys.filter((key) => key.startsWith('pollux-shell-')).map((key) => caches.delete(key)));
        }

        // Unregistering does not release the page that is already controlled.
        if (navigator.serviceWorker.controller) window.location.reload();
    } catch (err) {
        console.warn('Service worker cleanup failed:', err);
    }
}

export function registerServiceWorker() {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;

    if (!isProduction) {
        unregisterServiceWorkers();
        return;
    }

    window.addEventListener('load', () => {
        navigator.serviceWorker.register(`/service-worker.js?v=${getBuildId()}`)
            .catch((err) => {
                console.warn('Service worker registration failed:', err);
            });
    });
}

export async function getServiceWorkerRegistration() {
    if (!('serviceWorker' in navigator)) return null;
    // navigator.serviceWorker.ready never settles while nothing is registered.
    if (!isProduction) return null;
    try {
        return await navigator.serviceWorker.ready;
    } catch {
        return null;
    }
}
